import React from "react";
import avatars from "./images";
import "./Avatars.css";

export default function Avatars() {
  return (
    <div className="avatars-container">
      <h1 className="avatars-header">Avatars</h1>

      <div className="avatars-flex-wrapper">
        {avatars.map((avatar, index) => {
          return (
            <img
              className="avatars-image"
              src={avatar.src}
              key={index}
              alt={avatar.alt}
            />
          );
        })}
      </div>
    </div>
  );
}
